import { LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import { injectLegacyLightDomStyles } from '../common/light-dom-styles.js'
import style from './ItemActions.css'

/**
 * Item Actions holds the trailing controls of an [Item](/components/item/),
 * such as buttons or a chevron.
 *
 * @status draft
 * @category list
 * @lightDom true
 *
 * @slot - Default slot for the actions, such as buttons or an icon.
 */
@customElement('nord-item-actions')
export default class ItemActions extends LitElement {
  connectedCallback() {
    super.connectedCallback()
    injectLegacyLightDomStyles(this, style)
  }

  protected createRenderRoot() {
    return this
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'nord-item-actions': ItemActions
  }
}
